import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { api } from '@/global/services/api'

const DEFAULT_EMPTY_VALUE = '--'
export default {
  methods: {
    showEdit (event) {
      const { id, name } = event?.data || {}
      this.$router.push({
        name: 'PartnerGroup',
        params: {
          id
        },
        query: {
          partner_group: name || DEFAULT_EMPTY_VALUE
        }
      }).then()
    },

    onPartnerGroupActivation (event) {
      const { deactivated_at: deactivatedAt, id, name } = event?.data || {}
      if (!id) {
        return
      }
      const title = !deactivatedAt ? this.$t('administration/partner_group.deactivation') : this.$t('administration/partner_group.activation')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (name || '/'))
      this.$set(this.informationDialogConfig, 'positiveBtnText', !deactivatedAt ? this.$t('base.deactivate') : this.$t('base.activate'))
      this.$set(this.informationDialogConfig, 'message', !deactivatedAt ? this.$t('administration/partner_group.confirm_deactivation') : this.$t('administration/partner_group.confirm_activation'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.partnerGroupActivation(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async partnerGroupActivation (event) {
      try {
        const { id, deactivated_at: deactivatedAt } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.partnerGroups || {}
        await api('administration').patch(`partner-groups/${id}/${deactivatedAt ? 'activate' : 'deactivate'}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onPartnerGroupDelete (event) {
      const { id, name } = event?.data || {}
      if (!id) {
        return
      }

      const title = this.$t('administration/partner_group.deletion')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (name || '/'))
      this.$set(this.informationDialogConfig, 'positiveBtnText', this.$t('base.save'))
      this.$set(this.informationDialogConfig, 'message', this.$t('administration/partner_group.confirm_delete'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.partnerGroupDelete(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async partnerGroupDelete (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.partnerGroups || {}

        await api('administration').delete(`partner-groups/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
